import { Ranked } from "../types";

function sortByRankAscending<Element extends Ranked>(
  current: Element,
  next: Element,
): number {
  return current.rank < next.rank ? -1 : 1;
}

function sortByRankDescending<Element extends Ranked>(
  current: Element,
  next: Element,
): number {
  return current.rank < next.rank ? 1 : -1;
}

export { sortByRankAscending, sortByRankDescending };
